<template>
  <div>
    <peopleInputForm />
  </div>
</template>

<script>
import peopleInputForm from '@/components/peopleInputForm.vue'

export default {
  components: {
    peopleInputForm
  }
}
</script>
